<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Pembayaran Masuk & Total Transaksi</b-card-title>
    </b-card-header>
    <b-card-body>
      <!-- Pembayaran Masuk -->
      <h6 class="mb-50">
        Pembayaran Masuk
      </h6>
      <div
        v-for="(item, index) in paymentItems"
        :key="`payment-${index}`"
        class="d-flex justify-content-between align-items-baseline mb-50"
      >
        <span class="font-small-3 text-body d-flex align-items-center">
          {{ item.label }}
          <template v-if="item.tooltip">
            <feather-icon
              :id="`payment-tooltip-${index}`"
              icon="InfoIcon"
              size="16"
              class="cursor-pointer text-muted ml-50"
            />
            <b-tooltip
              :target="`payment-tooltip-${index}`"
              triggers="hover focus"
            >
              {{ item.tooltip }}
            </b-tooltip>
          </template>
        </span>
        <h5
          class="mb-0 text-nowrap ml-2"
          :class="valueClass(item)"
        >
          {{ toCurrency(item.value) }}
        </h5>
      </div>

      <hr class="my-2">

      <!-- Total Transaksi -->
      <h6 class="mb-50">
        Total Transaksi
      </h6>
      <div
        v-for="(item, index) in transactionItems"
        :key="`transaction-${index}`"
        class="d-flex justify-content-between align-items-baseline mb-50"
      >
        <span class="font-small-3 text-body d-flex align-items-center">
          {{ item.label }}
          <template v-if="item.tooltip">
            <feather-icon
              :id="`transaction-tooltip-${index}`"
              icon="InfoIcon"
              size="16"
              class="cursor-pointer text-muted ml-50"
            />
            <b-tooltip
              :target="`transaction-tooltip-${index}`"
              triggers="hover focus"
            >
              {{ item.tooltip }}
            </b-tooltip>
          </template>
        </span>
        <h5
          class="mb-0 text-nowrap ml-2"
          :class="valueClass(item)"
        >
          {{ toCurrency(item.value) }}
        </h5>
      </div>

      <hr class="my-1">

      <!-- Show Transactions Button -->
      <div class="mt-1">
        <b-button
          variant="primary"
          size="sm"
          block
          @click="showTransactions"
        >
          <feather-icon
            icon="FileTextIcon"
            size="14"
            class="mr-50"
          />
          Show Transactions
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BTooltip, BButton,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BTooltip,
    BButton,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    paymentItems() {
      return [
        {
          label: 'Seluruh Pembayaran',
          value: this.sumField('internal_sales_midtrans') + this.sumField('internal_sales_xendit'),
          tooltip: 'Seluruh pembayaran berhasil di Midtrans & Xendit',
        },
        {
          label: 'Total Midtrans',
          value: this.sumField('internal_sales_midtrans'),
        },
        {
          label: 'Total Xendit',
          value: this.sumField('internal_sales_xendit'),
        },
      ]
    },
    transactionItems() {
      const delivered = this.sumField('transaction_sales_delivered') || this.sumField('transaction_sales_completed')
      const processing = this.sumField('transaction_sales_processing')
      const cancelled = this.sumField('transaction_sales_cancelled') || this.sumField('transaction_sales_cancelled_paid')
      const totalAll = delivered + processing + cancelled

      return [
        {
          label: 'Seluruh Transaksi',
          value: totalAll,
          tooltip: 'Seluruh transaksi yang berhasil dibayar (Selesai + Diproses + Batal)',
        },
        {
          label: 'Transaksi Selesai',
          value: delivered,
          tooltip: 'Transaksi selesai (delivered)',
        },
        {
          label: 'Transaksi Diproses',
          value: processing,
          tooltip: 'Transaksi sedang diproses (accepted & pickedup)',
        },
        {
          label: 'Transaksi Batal',
          value: cancelled,
          tooltip: 'Transaksi terbayar yang dibatalkan (cancelled & rejected)',
        },
      ]
    },
  },
  methods: {
    sumField(field) {
      return this.data.reduce((total, el) => total + (Number(el[field]) || 0), 0)
    },
    valueClass(item) {
      return item.value ? '' : 'text-body font-weight-normal'
    },
    showTransactions() {
      let startDate = moment().startOf('month').format('YYYY-MM-DD')
      let endDate = moment().endOf('month').format('YYYY-MM-DD')

      if (this.filter && this.filter.startYear && this.filter.startMonth) {
        const sMonth = String(this.filter.startMonth).padStart(2, '0')
        startDate = moment(`${this.filter.startYear}-${sMonth}-01`).startOf('month').format('YYYY-MM-DD')
      }

      if (this.filter && this.filter.endYear && this.filter.endMonth) {
        const eMonth = String(this.filter.endMonth).padStart(2, '0')
        endDate = moment(`${this.filter.endYear}-${eMonth}-01`).endOf('month').format('YYYY-MM-DD')
      }

      const routeData = this.$router.resolve({
        name: 'dashboard-recapt-transactions',
        query: {
          date_range: 'custom',
          start_date: startDate,
          end_date: endDate,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>
